import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
// import top5RetailersData from '../data/top5.json';
import { isEmptyObject, getJCJPIDs } from "../../../../../utils/common/index";
import Top5RetailersView from "../../../../../views/activationSales/components/simConnectivity/top5RetailersView";

const Top5Retailers = (props) => {
  const dispatch = useDispatch();
  const { top5RetailersObj } = useSelector(
    (state) => state.activationSalesReducer
  );

  let {
    url,
    filterValue,
    headerSelectedDateFrom,
    headerSelectedDateTo,
    triggerTop5RetailersAPI,
  } = props;

  let { level, jioPointId, partnerRT, retailerId, id } =
    getJCJPIDs(filterValue);
  const headers = {
    id: id,
    partnerRoleType: partnerRT,
    fromDate: headerSelectedDateFrom,
    toDate: headerSelectedDateTo,
    section: props.section,
    moduleName: props.moduleName,
    jioPointId,
    retailerId,
    level,
  };

  useEffect(() => {
    function fetchTop5RetailersData() {
      const obj = {
        headers: {
          "Content-Type": "application/json",
          url: url,
        },
        params: headers,
        extraData: url,
      };
      return dispatch(triggerTop5RetailersAPI(obj));
    }
    if (isEmptyObject(top5RetailersObj && top5RetailersObj.top5RetailersData)) {
      fetchTop5RetailersData();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerTop5RetailersAPI, headerSelectedDateFrom, headerSelectedDateTo]);
  return <Top5RetailersView top5RetailersObj={top5RetailersObj} />;
};

Top5Retailers.propTypes = {
  url: PropTypes.string,
  filterValue: PropTypes.object,
  headerSelectedDateFrom: PropTypes.string,
  headerSelectedDateTo: PropTypes.string,
  triggerTop5RetailersAPI: PropTypes.func,
};

export default Top5Retailers;
